<sbw-popup2 *ngIf="showPopup" [heading]="content.tier3CategoryChangedHeader">
    <p>{{content.tier3CategoryChanged}}</p>
    <div class="row">
        <div class="column small-12 medium-6 medium-offset-6">
            <sbw-button (clicked)="showPopup=false" type="preferred" [text]="content.acceptAndContinue"></sbw-button>
        </div>
    </div>
</sbw-popup2>
